import type { SimpleFieldConfig } from "@/components/shared/UniversalCRMTable/types";
import { defineFieldConfigMap } from "@/components/shared/UniversalCRMTable/types/field-config-types";
import { Building2 } from "lucide-react";
import {
  ALL_STAFF_ROLES,
  ALL_STAFF_AND_CLIENT_ROLES,
} from "@west-tennessee-consulting/hub-roles";

// Company-related fields: company_name, company_id
export const companyContactFields = defineFieldConfigMap({
  // FIELD: company_name
  company_name: {
    type: "text",
    label: "Company Name",
    sortable: true,
    filterable: true,
    searchable: true,
    resizable: true,
    hideable: true,
    editable: false,
    isReadOnlyDerived: true,
    readOnlyReason: "Denormalized display field derived from company_id relation.",
    dataLineage: {
      kind: "denormalized",
      sourceTable: "companies",
      sourceField: "name",
      sourceForeignKeyField: "company_id",
      notes: "Read-only company label for table/detail rendering and filtering UX.",
    },
    excludeFromApi: true,
    formSpan: 3,
    filterType: "contains",
    width: 200,
    minWidth: 150,
    maxWidth: 300,
    placeholder: "Company name",
    icon: "Building2",
    // Role-based access control - visible to all roles
    allowedRoles: [...ALL_STAFF_AND_CLIENT_ROLES],
    showOnCard: true,
    cardSpan: 3,
    mobileDetailSectionId: "company",
    graphqlSelector: "company_name",
    savedViewMembership: [
      "all-contacts",
      "active-contacts",
      "customers",
      "leads",
      "prospects",
      "no-tickets-this-month",
      "with-tickets-this-month",
      "no-tickets-last-month",
      "with-tickets-last-month",
      "needs-follow-up",
      "contacts-with-contract",
      "contacts-without-contract",
      "cold-90-days",
      "contacts-with-active-deals",
      "contacts-without-active-deals",
    ],
  },
  // FIELD: company_id
  company_id: {
    type: "company-select",
    label: "Company",
    isForeignKey: true,
    foreignKey: {
      referencedTable: "companies",
      referencedColumn: "id",
      constraintName: "contacts_company_id_fkey",
      onDelete: "SET NULL",
      onUpdate: "NO ACTION",
      relationKind: "many-to-one",
    },
    dataLineage: {
      kind: "derived",
      sourceTable: "companies",
      sourceField: "id",
      notes: "Authoritative relationship key; user-editable via company selector.",
    },
    sortable: true,
    filterable: true,
    searchable: true,
    resizable: true,
    hideable: true,
    editable: true,
    filterType: "company-select",
    width: 200,
    minWidth: 150,
    maxWidth: 300,
    placeholder: "Search companies...",
    icon: "Building2",
    // Role-based access control - visible to all roles
    allowedRoles: [...ALL_STAFF_AND_CLIENT_ROLES],
    mobileDetailSectionId: "company",
    // graphqlSelector omitted: relation expands to nested `companies { id, name }`.
  },
});
